import React, { useEffect } from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import { withFormik, FormikProps } from 'formik';
import { Grid, Box, CircularProgress } from '@material-ui/core';

import { translate } from 'helpers/intl';
import messages from 'containers/PasswordRecoveryPages/InsertNewPassword/messages';
import validationSchema from 'containers/PasswordRecoveryPages/InsertNewPassword/ValidationSchema';
import PasswordInputField from 'components/InputField/Password';
import { StyledOrangeButton } from 'containers/PasswordRecoveryPages/InsertNewPassword/styles';
import GaClickHOC from 'helpers/GATracking/GaClickHOC';
import { EVENT_CATEGORIES } from 'helpers/GATracking';

const CreateNewPassword = (
  props: {
    isLoading: boolean;
    hasAmc?: boolean | undefined;
  } & FormikProps<FormValues>,
) => {
  const {
    values,
    touched,
    errors,
    handleSubmit,
    handleChange,
    handleBlur,
    isLoading,
    hasAmc,
    setFieldValue,
  } = props;

  useEffect(() => {
    if (hasAmc) {
      /* istanbul ignore next */
      setFieldValue('hasAmc', true);
    }
  }, [hasAmc]);

  return (
    <form onSubmit={handleSubmit}>
      <Box mb={7} mt={2} paddingX={[2, 4, 8]}>
        <Grid container spacing={2} direction="column" justify="flex-start">
          <Grid item xs={12}>
            <PasswordInputField
              name="newPassword"
              placeholder={translate({ ...messages.newPassword }, props)}
              value={values.newPassword}
              error={errors.newPassword && touched.newPassword}
              helperText={
                touched.newPassword && errors.newPassword
                  ? errors.newPassword
                  : ''
              }
              handleChange={handleChange}
              handleBlur={handleBlur}
              gAEventCategory={EVENT_CATEGORIES.FORGOTTEN_NEW_PASSWORD}
            />
          </Grid>

          <Grid item xs={12}>
            <PasswordInputField
              name="confirmPassword"
              placeholder={translate({ ...messages.confirmPassword }, props)}
              value={values.confirmPassword}
              error={errors.confirmPassword && touched.confirmPassword}
              helperText={
                touched.confirmPassword && errors.confirmPassword
                  ? errors.confirmPassword
                  : ''
              }
              handleChange={handleChange}
              handleBlur={handleBlur}
              gAEventCategory={EVENT_CATEGORIES.FORGOTTEN_NEW_PASSWORD}
            />
          </Grid>
          <Grid item xs={12}>
            <GaClickHOC
              category={EVENT_CATEGORIES.FORGOTTEN_NEW_PASSWORD}
              label="valider"
            >
              <StyledOrangeButton type="submit" variant="contained">
                {isLoading ? (
                  <CircularProgress data-testid="loader" size={20} />
                ) : (
                  <React.Fragment>
                    {translate(messages.valid, props)}
                  </React.Fragment>
                )}
              </StyledOrangeButton>
            </GaClickHOC>
          </Grid>
        </Grid>
      </Box>
    </form>
  );
};

export interface FormProps {
  intl: IntlShape;
  isLoading: boolean;
  onSubmit: Function;
  hasAmc?: boolean | undefined;
}

interface FormValues {
  confirmPassword: string;
  newPassword: string;
  hasAmc: boolean;
}

const Form = withFormik<FormProps, FormValues>({
  mapPropsToValues: () => {
    return {
      confirmPassword: '',
      newPassword: '',
      hasAmc: false,
    };
  },
  validationSchema,
  handleSubmit: ({ confirmPassword, newPassword, hasAmc }, { props }) => {
    return props.onSubmit({
      confirmPassword,
      newPassword,
      hasAmc,
    });
  },
})(CreateNewPassword);

export default injectIntl(Form);
